import React from 'react';
import moment from 'moment';
import { Transition, animated } from 'react-spring/renderprops.cjs';
import Loading from '@bit/knotchinc.web-react-components.loading';
import Error from '@bit/knotchinc.web-react-components.error';
import { chunkArray } from 'helpers/Utils.js';
import { TopSixListContainer, EntityListItemContainer, EntityIndex, TimeFilter, TickContainer, PageTick } from './styled';

const API_DATE_FORMAT = 'YYYY-MM-DD';

class TopSixList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      maxIndex: 0,
      switchIndex: setInterval(() => this.toggle(), 5000),
    };
  }

  componentDidMount() {
    window.addEventListener('focus', () => this.onFocus());
    this.fetchData();
  }

  componentDidUpdate() {
    this.fetchData();
  }

  componentWillUnmount() {
    window.removeEventListener('focus', () => this.onFocus());
    this.stopToggle();
  }

  onFocus() {
    this.setState({
      index: 0,
    });
  }

  fetchData() {
    const { store: { shouldFetch }, fetchStore } = this.props;

    if (shouldFetch && fetchStore) {
      if (this.request) this.request.abort();
      this.request = fetchStore(true);
    }
  }

  toggle() {
    this.setState({
      index: this.state.index >= this.state.maxIndex ? 0 : this.state.index + 1,
    });
  }

  startToggle() {
    this.setState({
      switchIndex: setInterval(() => this.toggle(), 5000),
    });
  }

  stopToggle() {
    clearInterval(this.state.switchIndex);
  }

  render() {
    const {
      width,
      columns,
      children,
      title,
      store,
      showIndex,
      showFilters,
      fetchStore,
      type,
      setFilters } = this.props;
    const { fetched, fetching, status, data, filters } = store;
    const noData = fetched && data.length === 0 && status === 'success';
    const error = fetched && (status === 'error' || status === 'not found');
    const ListElement = children.type;
    let renderedData = [];

    if (data && data.length) {
      const dataChunks = chunkArray(data, 6);
      if (dataChunks.length - 1 !== this.state.maxIndex) {
        this.setState({
          maxIndex: dataChunks.length - 1,
        });
      }
      renderedData = dataChunks.map((chunk) => (style) =>
        <animated.div style={{ ...style, columnCount: data.length && data.length > 4 ? columns : 1, height: '150px', width: '100%' }}>
          {chunk.map((item, index) =>
            <EntityListItemContainer key={`entity_container_${index}`}>
              {showIndex && <EntityIndex>{index + 1}</EntityIndex>}
              <ListElement type={type} data={item} key={`entity_${index}`} />
            </EntityListItemContainer>)}
        </animated.div>);
    }

    let timeFilters = null;
    if (showFilters && filters) {
      timeFilters = [90, 120, 365].map(time => {
        const startDate = moment().subtract(time, 'day').format(API_DATE_FORMAT);
        return (<TimeFilter
          key={`top_list_time_${time}`}
          selected={filters.start_date && startDate === filters.start_date}
          onClick={() => setFilters({ start_date: startDate, end_date: moment().format(API_DATE_FORMAT) })}
        >
          {`${time} Days`}
        </TimeFilter>);
      });
    }

    return (
      <TopSixListContainer width={width} onMouseEnter={() => this.stopToggle()} onMouseLeave={() => this.startToggle()}>
        {title}
        {timeFilters}
        <React.Fragment>
          {renderedData.length > 0 ?
            <React.Fragment>
              <Transition
                reset
                unique
                items={this.state.index}
                from={{ position: 'absolute', opacity: 0, transform: 'translate3d(100%,0,0)' }}
                enter={{ position: 'absolute', opacity: 1, transform: 'translate3d(0%,0,0)' }}
                leave={{ position: 'absolute', opacity: 0 }}
              >
                {index => renderedData[index]}
              </Transition>
              {renderedData.length > 1 ? <TickContainer>
                {renderedData.map((item, index) => (
                  <PageTick key={`tick_${index}`}onClick={() => this.setState({ index })} selected={index === this.state.index} />))}
              </TickContainer> : null}
            </React.Fragment>
          : null}
          {noData && <Error noData />}
          {fetching && <Loading />}
          {error && <Error fetchError reload={() => fetchStore(true)} />}
        </React.Fragment>
      </TopSixListContainer>
    );
  }
}

export default TopSixList;
